import EmblaCarousel from "embla-carousel";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DURATION, EASE } from "./animation-config.js";

gsap.registerPlugin(ScrollTrigger);
const HEADLINE_X = "-100vw";
const CAROUSEL_Y = "100%";

const reducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)",
).matches;

function initTestimonialsCarousel(root) {
  const viewport = root.querySelector(".testimonials__viewport");
  const prevButton = root.querySelector(".testimonials__nav--prev");
  const nextButton = root.querySelector(".testimonials__nav--next");

  if (
    !viewport ||
    viewport.querySelectorAll(".testimonials__slide").length < 2
  ) {
    prevButton?.setAttribute("hidden", "hidden");
    nextButton?.setAttribute("hidden", "hidden");
    return;
  }

  const embla = EmblaCarousel(viewport, {
    align: "center",
    loop: true,
  });

  prevButton?.addEventListener("click", () => {
    embla.scrollPrev();
  });

  nextButton?.addEventListener("click", () => {
    embla.scrollNext();
  });
}

function initTestimonialsSection(section) {
  const headline = section.querySelector(".testimonials__headline");
  const carousel = section.querySelector(".testimonials__carousel");

  if (!headline && !carousel) {
    return;
  }

  if (reducedMotion) {
    if (headline) {
      gsap.set(headline, { x: 0, opacity: 1 });
    }

    if (carousel) {
      gsap.set(carousel, { y: 0 });
    }

    section.classList.add("is-in-view");
    return;
  }

  if (headline) {
    gsap.set(headline, { x: HEADLINE_X, opacity: 0 });
  }

  if (carousel) {
    gsap.set(carousel, { y: CAROUSEL_Y });
  }

  ScrollTrigger.create({
    trigger: section,
    start: "top 70%",
    once: true,
    onEnter: () => {
      section.classList.add("is-in-view");

      const timeline = gsap.timeline({
        defaults: { duration: DURATION, ease: EASE },
      });

      if (headline) {
        timeline.to(headline, { x: 0, opacity: 1 }, 0);
      }

      if (carousel) {
        timeline.to(carousel, { y: 0 }, 0);
      }
    },
  });
}

document
  .querySelectorAll("[data-testimonials]")
  .forEach(initTestimonialsCarousel);
document.querySelectorAll(".testimonials").forEach(initTestimonialsSection);

window.addEventListener(
  "load",
  () => {
    ScrollTrigger.refresh();
  },
  { once: true },
);
